module.exports = __webpack_public_path__ + "media/images/icons/energie-icons-auto-circle-93dd1e516eae915e38d4a25f002f15e4.svg";